import { combineReducers } from '@reduxjs/toolkit'

import { reducer as detail } from './detail'

export default combineReducers({ detail })
